import { render } from "./MessageList.vue?vue&type=template&id=7a277303&scoped=true"
import script from "./MessageList.vue?vue&type=script&lang=ts"
export * from "./MessageList.vue?vue&type=script&lang=ts"

import "./MessageList.vue?vue&type=style&index=0&id=7a277303&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7a277303"

export default script